import { Input } from "@vintecc/components";
import { useMemo, useState } from "react";

interface DebugJsonPanelProps {
  label: string;
  data: unknown;
}

export const DebugJsonPanel: React.FC<DebugJsonPanelProps> = ({ label, data }) => {
  const [search, setSearch] = useState("");

  const displayLines = useMemo(() => {
    const lines = (JSON.stringify(data, null, 2) ?? "undefined").split("\n");
    const indexed = lines.map((line, i) => ({ number: i + 1, content: line }));

    if (!search.trim()) return indexed;

    return indexed.filter(({ content }) => content.toLowerCase().includes(search.toLowerCase()));
  }, [data, search]);

  return (
    <div role="cell" className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <span className="text-grey-500 text-xs font-sans">{label}</span>
        <Input placeholder="Filter..." value={search} onChange={(e) => setSearch(e.target.value)} className="w-40 text-xs" />
      </div>
      <pre className="bg-white rounded p-2 overflow-auto max-h-48 text-xs font-mono">
        {displayLines.length > 0 ? (
          displayLines.map(({ number, content }) => (
            <div key={number} className="flex gap-3">
              <span className="select-none text-right text-grey-300 w-8 shrink-0">{number}</span>
              <span className="whitespace-pre-wrap break-all border-l border-grey-200 pl-3">{content}</span>
            </div>
          ))
        ) : (
          <span className="text-grey-400 italic">No matches</span>
        )}
      </pre>
    </div>
  );
};
